import Vue from 'vue'
import Vuex from 'vuex'

import createMutationsSharer from 'vuex-shared-mutations'

import vuejsStorage from 'vuejs-storage'
Vue.use(vuejsStorage)

import chat from '@/store/storeChat'
import dialog from '@/store/storeDialog'
import scenario from '@/store/storeScenario'
import branch from '@/store/storeBranch'
import actions from '@/store/storeActions'
import design from '@/store/design'
import sockets from '@/store/storeSockets'
import articles from '@/store/articles'

Vue.use(Vuex)

import { ApiInit } from '@/api/api'

import { isMobileOnly } from 'mobile-device-detect'

// import { configureScope, captureMessage } from '@sentry/browser'

const getDefaultDrag = () => {
    return {
        drag: {
            over: false,
            errorInvalidFormat: false,
            sizeLimit: false,
            errorCount: false,
            text: ''
        }
    }
}

const getDefaultState = () => {
    return Object.assign(
        {
            device: {
                isMobileOnly
            },
            loader: true,
            lastChatId: false,
            ratingLinkId: false,
            active_chat_id: false,
            test: true,
            chatActive: false,
            chatActiveBtn: false,
            menuActive: false,
            dialogActive: false,
            pageWidgetFocus: true, // true Если хоть одна вкладка активна с виджетом
            loading: false,
            employee: {
                id: null,
                name: '',
                photo: '',
                first_name: ''
            },

            api: {
                loading: false,
                employee: {}
            },
            localStorage: {
                uuidCurrent: null, //для браузинга
                uuid: null,
                uuids: {},
                last_communication_time: null,
                initStart: false
            },
            sessionStorage: {
                session_start: 1,
                browsed_pages: [],
                scenarios_operations: [],
                scenarios_load_time: null,
                scenarios_last_operation_time: null
            }

            //api: apiTemp,
        },
        getDefaultDrag()
    )
}

const state = getDefaultState()

export default new Vuex.Store({
    modules: { chat, scenario, dialog, branch, actions, design, sockets, articles },
    state,
    plugins: [
        createMutationsSharer({
            predicate: (mutation, state) => {
                //console.log(mutation)
                const predicate = [
                    'setPageWidgetFocusTrue',
                    'setChatActive',
                    'setChatActiveBtn',
                    'setLocalStorage',
                    'setAuthGuestData',
                    'setLastAuthGuestData',

                    'dialog/setRatingChatNoClickHide',

                    'dialog/setChatCodeShow',
                    'dialog/setRightCode',
                    'dialog/setDialogToEmailShow',
                    'dialog/setNotificationShow',
                    'dialog/setGuestInfoNoSend',

                    'dialog/setRatingShow',
                    'dialog/setRateSmilesShow',
                    'dialog/setPersonalShow',
                    'dialog/setPersonalView',
                    'dialog/setSendFirstMessageClient',
                    'dialog/setNotificationTitle',
                    'dialog/setNoClickHideShowAfterMessage',
                    'dialog/setNoClickHideShowStartChatActive',
                    'dialog/setNoClickHideBeforeCall',
                    'dialog/setNoClickHideOffline',
                    'dialog/setGuestInfo',
                    'dialog/setPersonalBtnClick',
                    'dialog/setShowPhoneBell',
                    'dialog/setShowAfterDialogChatSmiles',

                    'branch/setOnlineNoSend',
                    'branch/setMenuModel',
                    'branch/setMenuShowAll',

                    'actions/setCallTextScenario',
                    'actions/setOfflineConnectsStep',
                    'actions/setOfflineConnectsMenuShowAll',
                    'actions/setOfflineConnectsMenuModel',
                    'actions/setCallOperatorRequest',
                    'actions/setCall',
                    'actions/setCallForm',

                    'design/setLocalStorage',

                    'chat/messageSend',
                    'chat/setUploadFileListPush',
                    'chat/setUploadFileListSplice',
                    'chat/setUploadFileListClear',
                    'chat/setShowSmiles'

                    //'scenario/setBoxHelloOpen'
                ]
                // Conditionally trigger other plugins subscription event here to
                // have them called only once (in the tab where the commit happened)
                // ie. save certain values to localStorage
                // pluginStateChanged(mutation, state)
                return predicate.indexOf(mutation.type) >= 0
            }
        }),
        vuejsStorage({
            namespace: 'effect-widget-store',
            keys: ['sessionStorage'],
            driver: vuejsStorage.drivers.sessionStorage
        }),
        vuejsStorage({
            namespace: 'effect-widget-store',
            keys: [
                'ratingLinkId',
                'lastChatId',
                'active_chat_id',
                'localStorage',
                'chatActive',
                'dialogActive',
                'chatActiveBtn',
                'dialog',
                'authGuestData',
                'lastAuthGuestData',
                //'sockets',
                //'scenario.boxHello',
                'branch.online.noSend',
                'branch.menu',
                'actions.offlineConnects',
                'actions.call',
                'design.localStorage',
                'design.buttonSize',
                'chat.showSmiles'
            ]
        })
    ],
    mutations: {
        setLoader(state, val) {
            state.loader = val
        },
        setOperator(state, { first_name, photo, id }) {
            if (photo) Vue.set(state.api.employee, 'photo', photo)
            Vue.set(state.api.employee, 'id', id)
            Vue.set(state.api.employee, 'first_name', first_name)
        },
        setPageWidgetFocusFalse(state) {
            state.pageWidgetFocus = false
        },
        setPageWidgetFocusTrue(state) {
            state.pageWidgetFocus = true
        },
        setApiActiveChatId(state, active_chat_id) {
            if (parseInt(active_chat_id) > 0) {
                state.lastChatId = active_chat_id
            }

            state.active_chat_id = active_chat_id
        },
        setApiLastChatId(state, last_chat_id) {
            state.lastChatId = last_chat_id
        },
        setRatingLinkId(state, link_id) {
            state.ratingLinkId = link_id
        },
        setAuthGuestData(state, authGuestData) {
            state.authGuestData = authGuestData
        },
        setLastAuthGuestData(state, authGuestData) {
            state.lastAuthGuestData = authGuestData
        },
        setDrag(state, field) {
            Object.assign(state.drag, field)

            if (!field.hasOwnProperty('over')) {
                setTimeout(() => {
                    Object.assign(state, getDefaultDrag())
                }, 2000)
            }
        },
        setMenuActive(state, boolean) {
            state.menuActive = boolean
        },
        setChatActive(state, boolean) {
            state.chatActive = boolean
        },
        setChatActiveBtn(state, string) {
            state.chatActiveBtn = string
        },
        setDialogActive(state, string = false) {
            state.dialogActive = string
        },

        resetState(state) {
            Object.assign(state, getDefaultState())
        },

        loading(state, val) {
            state.loading = val
        },
        setApi(state, val) {
            if (!val.uuid) return

            val.loading = true
            state.api = val

            state.localStorage.uuid = val.uuid
            state.localStorage.uuidCurrent = val.uuid //для браузинга
            state.localStorage.uuids = val.uuids
            const domain = location.hostname
                .split('.')
                .reverse()
                .splice(0, 2)
                .reverse()
                .join('.')
            function setCookie(name, value, days, domain) {
                let expires = ''
                if (days) {
                    const date = new Date()
                    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
                    expires = '; expires=' + date.toUTCString()
                }
                document.cookie =
                    name + '=' + (value || '') + expires + ';domain=.' + domain + ';path=/'
            }
            function deleteCookie(name, path, domain) {
                if (getCookie(name)) {
                    document.cookie =
                        name +
                        '=' +
                        (path ? ';path=' + path : '') +
                        (domain ? ';domain=' + domain : '') +
                        ';expires=Thu, 01 Jan 1970 00:00:01 GMT'
                }
            }
            function getCookie(name) {
                return document.cookie.split(';').some(c => {
                    return c.trim().startsWith(name + '=')
                })
            }

            deleteCookie('uuids', '/', domain)
            deleteCookie('effect-uuids', '/', domain)
            setCookie('effect-uuid', val.uuid, 9999, domain)
            setCookie('effect-uuids', encodeURIComponent(JSON.stringify(val.uuids)), 9999)
            // configureScope(function(scope) {
            //     scope.setUser({
            //         id: val.uuid,
            //         email: val.login
            //     })
            // })
        },
        setSessionStorageBrowsedPages(state) {
            if (state.sessionStorage.browsed_pages.indexOf(window.location.href) === -1) {
                state.sessionStorage.browsed_pages.push(window.location.href)
            }
        },
        setSessionStorage(state, [field, val]) {
            state.sessionStorage[field] = val
        },
        setLocalStorage(state, [field, val]) {
            state.localStorage[field] = val
        },
        setSessionStart(state) {
            if (state.sessionStorage.session_start) {
                state.sessionStorage.session_start = 0
            }
        },
        localStorageUpdate(state, val) {
            if (val) {
                Object.assign(state, val)
            }
        }
    },
    actions: {
        init({ state, commit, dispatch }, params) {
            return new Promise(resolve => {
                ApiInit.init(params)
                    .then(({ data }) => {
                        commit('setApi', data)
                        //this.registerModule('design', design)
                        commit('design/setApi', data)
                        commit('dialog/setApi', data)
                        commit('branch/setApi', data)
                        commit('actions/setApi', data)
                        commit('setSessionStart')
                        commit('setApiActiveChatId', data.active_chat_id)
                        commit('setApiLastChatId', data.last_chat_id)
                        resolve()
                    })
                    .catch(err => {
                        console.log(err)
                    })
            })
        }
    },
    getters: {
        showDrag: state => {
            return Object.values(state.drag).some(item => item)
        },

        /* isOnlineCommunication: state => {
            if (!state.api.loading) return false

            return state.api.working_branches_to_chat.length

        },*/
        isOnlineCall: state => {
            if (!state.api.loading) return false

            return state.branch.working_branches_to_call.length
        },
        getChatActive: state => {
            return state.chatActive
        },

        /*  operatorName: state => {
            return state.api?.employee?.first_name || state.api?.employee?.name
        },*/
        operator: state => {
            if (!state.api.loading) return {}
            let online =
                state.branch.working_branches_to_chat.length > 0 ||
                (state.active_chat_id && state.api.employee.id)
            if (online && state.api.options.widget_stub.enabled) online = false
            return {
                online,
                photo: state.api.employee.photo
            }
        },
        channels: state => state.api.channels?.filter(item => item.is_enabled) || []
    }
})
